import React from 'react'
import './navbar.scss'


function Navbar() {

   
    return (
        <div className="Navbar">
            <div className="leftSide">
                <div>Microsoft Learn Student Ambassador</div>
                <img src="/images/logo.png" alt=""/>
            </div>
            
            
            
        </div>
    );
}

export default Navbar